import React from 'react';
import styled, { keyframes, createGlobalStyle } from 'styled-components';
import en from '../../language/Eng.json';
import TopMenu from './Top_Menu';
import Bottom from './Bottom';

const FontFaceStyle = createGlobalStyle`
  @font-face {
    font-family: 'Inkfree';
    src: url('/font/Inkfree.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
`;

const PageWrapper = styled.div`
  background-color: #F4F1E6;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 160px 6vw 100px;
  box-sizing: border-box;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  color: #48200cff;

  @media (max-width: 768px) {
    padding: 120px 20px 60px;
  }
`;

const LayoutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  animation: ${slideUp} 0.8s ease forwards;
`;

const Tag = styled.div`
  font-size: 12px;
  letter-spacing: 2px;
  color: #48200cff;
  margin-bottom: 20px;
  text-transform: uppercase;
`;

const MainTitle = styled.h1`
  font-size: clamp(32px, 4vw, 52px);
  font-weight: 400;
  line-height: 1.2;
  color: #9e5e04;
  margin: 0;
  font-family: 'Inkfree', serif;
`;

const Description = styled.p`
  font-family: 'Inkfree', serif;
  font-size: 1.1rem;
  line-height: 1.8;
  color: #9e5e04;
  opacity: 0.9;
  max-width: 500px;
  white-space: pre-line;
`;

const SubSection = styled.div`
  margin-top: 20px;
  border-top: 1px solid rgba(91, 44, 22, 0.2);
  padding-top: 30px;
`;

const SubTitle = styled.h2`
  font-size: 0.9rem;
  letter-spacing: 1px;
  color: #48200cff;
  margin-bottom: 15px;
`;

const ImageSection = styled.div`
  width: 100%;
  animation: ${slideUp} 1s ease forwards;
  animation-delay: 0.2s;
  opacity: 0;

  img {
    width: 100%;
    aspect-ratio: 1080 / 1350;
    object-fit: cover;
    filter: sepia(20%);
  }
`;

const About: React.FC = () => {
  const { aboutPage } = en;

  return (
    <PageWrapper>
      <FontFaceStyle />
      <TopMenu />
      <MainContent>
        <LayoutGrid>
          <TextSection>
            <div>
              <MainTitle>{aboutPage.mainTitle}</MainTitle>
            </div>

            <Description>
              {aboutPage.description}
            </Description>
          </TextSection>

          <ImageSection>
            <img src="/image/background/back13.webp" alt={aboutPage.imageAlt} />
          </ImageSection>
        </LayoutGrid>
      </MainContent>
      <Bottom />
    </PageWrapper>
  );
};

export default About;